/* case-study.js: motion for the case-study family (layout/case-study.liquid + templates/page.case-study-*.liquid).
   Everything is visible at rest. This file only animates toward that state:
   - [data-cs-anim] units whose top edge is below the viewport at DOMContentLoaded get data-anim="pending"
     (the only state case-study.css hides) and flip once to data-anim="in" when they scroll in.
   - [data-cs-anim="load"] units above the fold (the hero) flip to "in" 150 ms after DOMContentLoaded.
   - Inside a unit that flips, [data-count-to] numbers tween from data-count-from to their final DOM value.
   - The top bar goes dark while the hero ([data-cs-hero]) is under it.
   No IntersectionObserver, or prefers-reduced-motion: reduce -> do nothing; the page stays at rest. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var BAR = 64;

  // Count tween: requestAnimationFrame, ease-out cubic, 900 ms, integers only. Starts 300 ms into the unit's
  // entrance, staggered 80 ms, so each count lands with its check (case-study.css: 1200 ms + i * 80 ms).
  function tween(el, i) {
    var from = parseInt(el.getAttribute('data-count-from'), 10);
    var to = parseInt(el.getAttribute('data-count-to'), 10);
    if (isNaN(from) || isNaN(to)) return;
    el.textContent = from;
    setTimeout(function () {
      var t0 = null;
      function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min((now - t0) / 900, 1);
        el.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)));
        if (p < 1) window.requestAnimationFrame(step);
        else el.textContent = to;
      }
      window.requestAnimationFrame(step);
    }, 300 + i * 80);
  }

  // Flip a unit to "in" (once). The CSS entrances and the connector draws key off this attribute.
  function play(unit) {
    if (unit.getAttribute('data-anim') === 'in') return;
    unit.setAttribute('data-anim', 'in');
    var counts = unit.querySelectorAll('[data-count-to]');
    for (var i = 0; i < counts.length; i++) tween(counts[i], i);
  }

  function init() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        play(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 });

    var units = document.querySelectorAll('[data-cs-anim]');
    for (var i = 0; i < units.length; i++) {
      (function (unit) {
        if (unit.getBoundingClientRect().top > vh) {
          unit.setAttribute('data-anim', 'pending');
          io.observe(unit);
        } else if (unit.getAttribute('data-cs-anim') === 'load') {
          setTimeout(function () { play(unit); }, 150);
        }
      })(units[i]);
    }

    // Top bar: dark while the hero crosses the bar's bottom edge. The root is collapsed to the line 64 px below
    // the viewport top (top margin -64 px, bottom margin -(viewport - 64) px).
    var bar = document.querySelector('.cs-topbar');
    var hero = document.querySelector('[data-cs-hero]');
    if (bar && hero) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('cs-topbar--dark', entries[entries.length - 1].isIntersecting);
      }, { rootMargin: '-' + BAR + 'px 0px -100% 0px' }).observe(hero);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
